import { Button, Tooltip } from "antd";
import styled from "styled-components";

const Style = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: var(--size-lg);

  &.mt-0 {
    margin-top: 0;
  }

  .ant-btn {
    width: 75px;
  }
`;

export default function Footer({
  onClose = () => { },
  onSubmit = () => { },
  t = (s) => s,
  loading,
  className,
  disabledFooterText,
  disabledFooter,
}) {
  return (
    <Style className={className}>
      {!!disabledFooterText ? (
        <Tooltip title={t(disabledFooterText)}>
          <Button
            type="primary"
            onClick={onSubmit}
            disabled
          >
            {t(loading ? 'Loading...' : 'Save')}
          </Button>
        </Tooltip>
      ) : (
        <Button
          type="primary"
          onClick={onSubmit}
          disabled={disabledFooter}
        >
          {t(loading ? 'Loading...' : 'Save')}
        </Button>
      )}
      <Button onClick={onClose}>
        {t('Cancel')}
      </Button>
    </Style>
  );
}
